// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2kMk_","aviaTicketsBtn":"aviaTicketsBtn-13Zu_","hotelsBtn":"hotelsBtn-3rIer"};